import { Link } from "@solidjs/router";
import { Show, For, Component, onMount } from "solid-js";
import { Img } from "./universal/image";
import { LivingArtistArtwork,  UserSession, NewImage } from "../types";
import { createStore } from "solid-js/store";
import { fetchGet } from "../library/common";
import { Button } from "solid-bootstrap";
import { RawHtml } from "./raw-html";
import toast from "solid-toast";
import { CMS } from "./cms/cms";
import { getPlainText, loadCms } from "../app";
import { getFileName } from "../API";
import { DateTime } from "./date-time";

export type ArtworkProps = {
    session: UserSession;
    artwork: LivingArtistArtwork;
    resources: {
        canApply: boolean;
    };
    deleteClicked: (id: string) => void;
};

type State = {
    isContentReady: boolean;
}
export const Artwork : Component<ArtworkProps> = (props) => {
    const canApply: boolean = props.resources.canApply;
    const [state, setState] = createStore<State>({ isContentReady: false });
    const [artwork, setArtwork] = createStore<LivingArtistArtwork>(props.artwork);
    const deleteArtworkClicked = (artwork: LivingArtistArtwork) =>{
        console.log("deleteArtworkClicked", { artwork });
        if (confirm(getPlainText("dialog::sure-you-wish-to-delete-this-entry", "Are you sure you wish to delete this entry?"))) {
            props.deleteClicked(artwork.Id);
        }
    };
    const deleteImageClicked = async (image: NewImage) => {
        if (!confirm(getPlainText("dialog::are-you-sure-you-wish-to-delete-image", "Are you sure you wish to delete this image?"))) {
            return;
        }
        const model = {
            ArtworkId: artwork.Id,
            NewImageId: image.Id
        };
        const response = await fetchGet("/LivingArtistApplication/DeleteArtworkImageJson", model);
        const json = await response.json();
        console.log("deleteImageClicked", { json });
        if (!json.Success) return;
        const remaining = artwork.Images.filter(img => img.NewImage.Id != image.Id);
        console.log("deleteImageClicked", { images: artwork.Images, remaining });
        setArtwork("Images", remaining);
        toast.success(`Image "${getFileName(image.URL)}" has been deleted.`);
    };
    onMount(async () => {
        const ids=[
            "label::medium","label::purchase-award-nominated-price","label::size","label::completed-in","label::location","label::about-this-artwork",
            "label::categories","label::images",
            "salon-application/step-2::salon-artwork/file-details",
            "button::view","button::edit","button::delete","button::add",
            "button::remove",
            "error::category/unable-to-enter","error::category/select-from-list",
            "dialog::sure-you-wish-to-delete-this-image","dialog::sure-you-wish-to-delete-this-entry",
            "error::category/unable-to-remove-artwork","error::category/unable-to-enter"
        ];
        await loadCms(ids);
        setState("isContentReady", true);
    });
    return (
        <Show when={state.isContentReady}>
            <div class="artwork-container">
                <div style="padding: 10px 20px; padding-bottom: 0; position: relative;">
                    <p style="font-size: 0.8em;">
                        <b>
                            Added on <DateTime value={artwork.DateCreated} format="MM/DD/YYYY h:mm A" /> PST
                        </b>
                    </p>
                </div>
                <div style="padding: 0 20px;">
                    <h3>
                        {artwork.Title}
                        <Show when={canApply}>
                            <div style="float: right;">
                                <Button variant="primary" style="margin-right: 5px;" href={ "#/edit-artwork/" + artwork.Id }>Edit</Button>
                                <Button variant="outline-danger" onClick={(e) => { e.preventDefault(); deleteArtworkClicked(artwork); }}>Delete</Button>
                            </div>
                        </Show>
                    </h3>
                    <table class="artwork-details-table">
                        <thead>
                            <tr>
                                <td style="width: 150px;"></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ "border-top": "1px dotted #ccc"}}>
                                <td>
                                    <CMS id="label::medium" text>Medium</CMS>
                                </td>
                                <td>
                                    {artwork.Medium}
                                </td>
                            </tr>
                            <tr style={{ "border-top": "1px dotted #ccc"}}>
                                <td>
                                    <CMS id="label::size" text>Size</CMS>
                                </td>
                                <td>
                                    <div innerHTML={artwork.Measurements || ""}></div>
                                </td>
                            </tr>
                            <tr style={{ "border-top": "1px dotted #ccc"}}>
                                <td>
                                    <CMS id="label::about-this-artwork" text>About this artwork</CMS>
                                </td>
                                <td>
                                    <RawHtml value={artwork.Comment} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="padding: 10px 20px; border-top: 1px solid #ccc;">
                    <h4>
                        <CMS id="label::images" text>Images</CMS>
                        <label style="float:right;">
                            <Button variant="primary" href={ "#/add-image-to-artwork/" + artwork.Id }><CMS id="button::add" text>Add</CMS></Button>
                        </label>
                    </h4>
                </div>
                <div style="background-color: #000; color: #fff; padding: 10px;">
                    <div class="row">
                        <div class="col-md-12">
                            <For each={artwork.Images}>{(artworkImage, index) =>
                                <div style="display: inline-block; width: 49%; margin-right: 3px; vertical-align: top;">
                                    <div onClick={(e) => { e.preventDefault(); alert((index()+1) + " clicked")}} style={{ "background-color": "goldenrod", "padding": "3px" }}>
                                        #{index()+1}
                                    </div>
                                    <div>
                                        <Link href={ `/edit-image/${artwork.Id}/${artworkImage.Id}` }>
                                            <Img src={ artworkImage.NewImage.URL } mode="crop" width={300} format="jpg" style="width: 100%;" />
                                        </Link>
                                    </div>
                                    <div style="padding: 10px;">
                                        <div>
                                            <CMS id="salon-application/step-2::salon-artwork/file-details"
                                                data={{ height: artworkImage.NewImage.Height, width: artworkImage.NewImage.Width, fileSize: artworkImage.NewImage.FileSizeBytes }}>
                                                TEST
                                            </CMS>
                                        </div>
                                        <div style="margin-top: 10px;">
                                            <Link class="btn btn-sm btn-default" style="margin-right: 10px;" href={ `/view-image/${artwork.Id}/${artworkImage.NewImage.Id}` }>
                                                <CMS id="button::view" text>View</CMS>
                                            </Link>
                                            <Link class="btn btn-sm btn-primary" style="margin-right: 10px;" href={ `/edit-image/${artwork.Id}/${artworkImage.NewImage.Id}` }>
                                                <CMS id="button::edit" text>Edit</CMS>
                                            </Link>
                                            <a class="btn btn-sm btn-danger" onClick={(e) => { e.preventDefault(); deleteImageClicked(artworkImage.NewImage); }} style="margin-right: 10px;">
                                                <CMS id="button::delete" text>Delete</CMS>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            }</For>
                        </div>
                    </div>
                </div>
            </div>
    </Show>
    );
}